module.exports = __webpack_public_path__ + "static/media/covi_par.7bbe6d45.png";